import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const DrivingDetailsSkeleton: React.FC = () => (
  <Card>
    <CardHeader title={<Skeleton variant="text" width={120} />} />
    <Divider />
    <CardContent>
      <Grid container spacing={7}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" height={40} width={120} />
          <Skeleton variant="rect" height={350} />
          <Skeleton variant="text" height={40} width={120} />
          <Skeleton variant="rect" height={200} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" height={40} width={120} />
          <Skeleton variant="rect" height={350} />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default DrivingDetailsSkeleton;
